import React, { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';

export const SubNav = React.forwardRef<HTMLDivElement, PropsWithChildren<{}>>(
  (props, ref) => {
    return (
      <div ref={ref} className="subnav">
        <ul className="nav">{props.children}</ul>
      </div>
    );
  }
);

type SubNavLinkProps = PropsWithChildren<{
  routeTo: string;
  exact?: boolean;
}>;

export const SubNavLink = React.forwardRef<HTMLLIElement, SubNavLinkProps>(
  (props, ref) => {
    const { children, exact, routeTo } = props;
    return (
      <li ref={ref} className="nav-item">
        <NavLink
          className="nav-link"
          role="tab"
          type="button"
          to={routeTo}
          activeClassName="active"
          exact={exact}>
          {children}
        </NavLink>
      </li>
    );
  }
);
